module.exports = __webpack_public_path__ + "img/file-alt.af630b38.svg";